
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate/marketplace",
      function () {
        return require("private-next-pages/affiliate/marketplace.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate/marketplace"])
      });
    }
  